import { useCallback, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import Routes from "@/routes"

import { useNotificationsStore } from "stores/notifications"

const UNREAD_NOTIFICATIONS_REFRESH_TIMEOUT_MS = 10000

export function useUnreadNotificationRefresh() {
    const location = useLocation()
    const { fetchUnreadNotificationCount } = useNotificationsStore()
    const fetchTimeout = useRef<NodeJS.Timeout | null>(null)

    const fetchUnreadNotificationCountWithTimeout = useCallback(() => {
        if (fetchTimeout.current) return
        fetchUnreadNotificationCount()
        fetchTimeout.current = setTimeout(() => {
            fetchTimeout.current = null
        }, UNREAD_NOTIFICATIONS_REFRESH_TIMEOUT_MS)
    }, [fetchUnreadNotificationCount])

    useEffect(() => {
        // on notifications page counter is update separately
        if (location.pathname === Routes.notifications.getPath()) return
        fetchUnreadNotificationCountWithTimeout()
    }, [fetchUnreadNotificationCountWithTimeout, location.pathname])
}
